module.exports = __webpack_public_path__ + "assets/media/mike-volpe.5c68d24d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/LolaTestimonial/mike-volpe.svg
// module id = 1992
// module chunks = 0